import PropTypes from 'prop-types';
import React from 'react';

import Filter, { FilterModal, FilterSection } from '../../SearchPage/Filters/Filter';
import RadioFilter from '../../SearchPage/Filters/FilterComponents/CoreComponents/RadioFilter';
import {
    getRecruitingStatusFilterLabel,
    RECRUITING_STATUS_FILTER,
    RECRUITING_STATUS_FILTER_OPTIONS,
} from '../pages/CollegeCornerJuniorProspects/cppConstants';

import styles from '../../SearchPage/search.scss';

const filterName = 'recruitingStatus';

const RecruitingStatusFilter = (props) => {
    const {
        type,
        filters,
        filterInputs,
        handleFilterClick,
        filterModal,
        closeModals,
        handleFilterSubmit,
        handleFilterUpdate,
        mobileOnly,
        desktopOnly,
        'data-testid': dataTestId,
    } = props;

    const selected = filters?.recruitingStatus;
    const isActive =
        (selected && selected !== RECRUITING_STATUS_FILTER.ALL) || filterModal === filterName;

    return (
        <div className={styles.filterWrapper}>
            <Filter
                filterName={filterName}
                handleFilterClick={handleFilterClick}
                isActive={isActive}
                onClick={() => handleFilterClick(filterName)}
                searchFor={type}
                mobileOnly={mobileOnly}
                desktopOnly={desktopOnly}
                data-testid={dataTestId}
            >
                {getRecruitingStatusFilterLabel(selected)}
            </Filter>
            {filterModal === filterName && (
                <FilterModal
                    title={'Status'}
                    handleFilterSubmit={handleFilterSubmit}
                    onCloseClick={closeModals}
                    data-testid={dataTestId}
                >
                    <FilterSection>
                        <RadioFilter
                            name={filterName}
                            options={RECRUITING_STATUS_FILTER_OPTIONS}
                            selected={filterInputs.recruitingStatus}
                            onChange={(recruitingStatus) => {
                                handleFilterUpdate({ recruitingStatus });
                            }}
                            data-testid={dataTestId && `${dataTestId}.options`}
                        />
                    </FilterSection>
                </FilterModal>
            )}
        </div>
    );
};

RecruitingStatusFilter.propTypes = {
    type: PropTypes.string,
    filters: PropTypes.instanceOf(Object).isRequired,
    filterInputs: PropTypes.instanceOf(Object).isRequired,
    filterModal: PropTypes.string.isRequired,
    handleFilterClick: PropTypes.func,
    closeModals: PropTypes.func,
    handleFilterSubmit: PropTypes.func,
    handleFilterUpdate: PropTypes.func,
    mobileOnly: PropTypes.bool,
    desktopOnly: PropTypes.bool,
    'data-testid': PropTypes.string,
};

RecruitingStatusFilter.defaultProps = {
    type: '',
    handleFilterClick: () => { },
    closeModals: () => { },
    handleFilterSubmit: () => { },
    handleFilterUpdate: () => { },
    mobileOnly: false,
    desktopOnly: false,
    'data-testid': null,
};

export default RecruitingStatusFilter;
